

    const encoding = 'utf-8';

    const ParseDBFHeader = (buffer) => {
        return new Promise(
            (resolve, reject) => {

                const type = buffer.slice(0, 1).toString(encoding);
                const dateUpdated = parseDate(buffer.slice(1, 4));
                const numberOfRecords = convertBinaryToInteger(buffer.slice(4, 8));
                const start = convertBinaryToInteger(buffer.slice(8, 10));
                const recordLength = convertBinaryToInteger(buffer.slice(10, 12));

                const result = [];
                for (let i = 32, end = start - 32; i <= end; i += 32) {
                    result.push(buffer.slice(i, i+32));
                }

                const fields = result.map(parseFieldSubRecord.bind(this));

                resolve({
                    type,
                    dateUpdated,
                    numberOfRecords,
                    recordLength,
                    fields,
                    start
                });
            }
        )
    }

    const parseDate = (buffer) => {
        const year = 1900 + convertBinaryToInteger(buffer.slice(0, 1));
        const month = (convertBinaryToInteger(buffer.slice(1, 2))) - 1;
        const day = convertBinaryToInteger(buffer.slice(2, 3));

        return new Date(year, month, day);
    }

    const parseFieldSubRecord = (buffer) => {
        return {
            name: (buffer.slice(0, 10)).toString(encoding).replace(/[\u0000]+$/, ''),
            type: (buffer.slice(11, 12)).toString(encoding),
            displacement: convertBinaryToInteger(buffer.slice(12, 16)),
            length: convertBinaryToInteger(buffer.slice(16, 17)),
            decimalPlaces: convertBinaryToInteger(buffer.slice(17, 18))
        };
    }

    const convertBinaryToInteger = (buffer) => {
        return buffer.readIntLE(0, buffer.length);
    }

export default ParseDBFHeader;